import React from "react"
import { Helmet } from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

function SEO(props) {
    return (
        <StaticQuery
            query={
                graphql`
                    query HeadingQuery {
                        site {
                            siteMetadata {
                                description
                            }
                        }
                    }
                `}
            render = {data => (
                <Helmet>
                <meta charSet="utf-8" />
                <title>{props.title}</title>
                <meta name="description" content={data.site.siteMetadata.description} />
                </Helmet>
            )}
        />
    )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        description
      }
    }
  }
`

export default SEO
